import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {
  ExceedsNonPrimaryVolumeStatisticsSnapshot,
  ExceedsNonPrimaryVolumeStatisticsSnapshotEntity
} from "../../../model/exceeds-non-primary-volume-statistics-snapshot";

export type ExceedsNonPrimaryVolumeStatisticsSnapshotSelectorProps = {
  // selector props
};

export const exceedsNonPrimaryVolumeStatisticsSelector = () => createSelector(
  [getUseQueryResultData<ExceedsNonPrimaryVolumeStatisticsSnapshot[]>],
  (data) => {
    return selectExceedsNonPrimaryVolumeStatisticsSnapshotsAndTransform(
      data ?? [], {});
  }
);

export const exceedsNonPrimaryVolumeStatisticSelector = () => createSelector(
  [getUseQueryResultData<ExceedsNonPrimaryVolumeStatisticsSnapshot>],
  (data) => {
    return data ? transformExceedsNonPrimaryVolumeStatisticsSnapshot(data) : undefined;
  }
);

export const selectExceedsNonPrimaryVolumeStatisticsSnapshots = (values?: ExceedsNonPrimaryVolumeStatisticsSnapshot[], selector?: ExceedsNonPrimaryVolumeStatisticsSnapshotSelectorProps): ExceedsNonPrimaryVolumeStatisticsSnapshot[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const transformExceedsNonPrimaryVolumeStatisticsSnapshot = (value: ExceedsNonPrimaryVolumeStatisticsSnapshot): ExceedsNonPrimaryVolumeStatisticsSnapshotEntity => {
  return ExceedsNonPrimaryVolumeStatisticsSnapshotEntity.from(value)
}

export const selectExceedsNonPrimaryVolumeStatisticsSnapshotsAndTransform = (values?: ExceedsNonPrimaryVolumeStatisticsSnapshot[], selector?: ExceedsNonPrimaryVolumeStatisticsSnapshotSelectorProps): ExceedsNonPrimaryVolumeStatisticsSnapshotEntity[] => {
  const selected = selectExceedsNonPrimaryVolumeStatisticsSnapshots(values, selector);
  return selected.map(transformExceedsNonPrimaryVolumeStatisticsSnapshot);
};
